var React = require('react');

function ChevronUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.298 11.214L1.872 9.813l5.415-5.514a1 1 0 0 1 1.426 0l5.415 5.514-1.426 1.401L8 6.427l-4.702 4.787z","fill":"currentColor"}));
}

ChevronUpInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ChevronUpInline;

ChevronUpInline.default = ChevronUpInline;
